
export const Currencyformatters:ICurrencyFormatter=
{
USD : new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD'}),
EUR: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }),
JPY: new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }),
CAD: new Intl.NumberFormat('en-US', {style: 'currency', currency: 'CAD'})
}


export interface ICurrencyFormatter
{
  [key:string]:Intl.NumberFormat
}